
/*eslint-disable*/
import React from "react";
// react library for routing
// reactstrap components
import {
    Button,
    Card, CardBody, CardHeader,
    CardImg,
    CardSubtitle,
    CardTitle,
    Col,
    Collapse,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    UncontrolledTooltip
} from 'reactstrap';
// core components
import ContentService from "../services/xgContentService";
import _ from "lodash";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import Paginations from "./Paginations";
import FormReactSelect from "../components/common/form/FormReactSelect";
import {contentType} from "../util/contentType";
import {contentCategory} from "../util/contentCategory";
import {isMobile} from "react-device-detect";
import AppNavBar from "./AppNavBar";
import NotificationAlert from "react-notification-alert";
import SecurityService from "../services/securityService";
import isTrainingSession from "./pages/util/isTrainingSession";
import {subscriptionType} from "../util/subscriptionType";
import {contentArticleType} from "../util/contentArticleType";
import ReviewService from "../services/reviewService";
import DownloadUtil from "../util/downloadUtil";
import ReviewCompaniesCarousel from "./ReviewCompaniesCarousel";
import Rating from "react-rating";
import CardFooter from "reactstrap/es/CardFooter";

class XareView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            term: "",
            collapseSearchServices: false,
            collapseSearchArticles: false,
            collapseSearchReviews: false,
            completeContentList: [],
            searchList: [],
            loginModal: false,
            currentPage: 1,
            pageSize: 9, // 8 items to display 4 per row (2 rows per page)
        };
        this.onPageChange = this.onPageChange.bind(this);
    }

    onPageChange(pageNumber) {
        this.setState({currentPage: pageNumber});
    }

    trimmedTitle = (title) => {
        if (!title) return '';

        if (title.length > 60) {
            return title.substring(0, 60) + '...';
        }

        // Add non-breaking spaces (&nbsp;) to make it exactly 60 characters
        return title + '\u00A0'.repeat(60 - title.length);
    };


    icon = (item) => {
        let icon;
        switch (item.contentType) {
            case 'TEXT':
                icon = "fa fa-file-alt";
                break;
            case 'VIDEO':
                icon = "fa fa-video";
                break;
            case 'AUDIO':
                icon = "fa fa-headphones";
                break;
            default:
                icon = "fa fa-file-alt"; // Default icon if type is unknown
        }
        return icon;
    }

    componentDidMount() {
        ReviewService.xareviewData().then((response) => {
            console.log(response);
            this.setState({completeContentList: response});
            this.setState({searchList: response});
            this.toggleSearchReviews();
        });
    }

    onPageChange(pageNumber) {
        this.setState({currentPage: pageNumber});
    }

    renderCards(items) {
        let obj = this;
        return (
            <Container className="mt-4 mb-4">
                <Row className="gx-4 gy-4 justify-content-center">
                    {items.map((item) => (
                        <Col key={UtilService.uuidv4()} xs="12" sm="6" md="4" lg="3">
                            <div
                                onClick={() => {
                                    obj.props.history.push(`/company/${item.companyId}`);
                                }}
                                className="p-3 rounded shadow-sm h-100"
                                style={{
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #e7eaf0",
                                    cursor: "pointer",
                                    transition: "transform 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.09)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                }}
                            >
                                {/* Image on top */}
                                <div className="text-left mb-2">
                                    <img
                                        src={
                                            item.brandLogoUID === null
                                                ? require("assets/img/brand/companies.jpeg")
                                                : DownloadUtil.generateUrl(item.brandLogoUID)
                                        }
                                        alt="Company Logo"
                                        style={{
                                            width: "50%",
                                            height: "60&",
                                            objectFit: "contain",
                                            borderRadius: "4px",
                                        }}
                                    />
                                </div>

                                {/* Text content below */}
                                <div className="text-left">
                                    <h5 className="font-weight-bold text-dark">{item.companyName}</h5>
                                    <div className="">
                                        <Rating
                                            readonly
                                            initialRating={item.score}
                                            emptySymbol={<i className="fa fa-star text-muted"/>}
                                            fullSymbol={<i className="fa fa-star text-warning"/>}
                                            fractions={2}
                                            title={item.score?.toFixed(1)}
                                        />
                                        &nbsp;
                                        <span className=" text-muted" style={{fontSize: "0.9rem"}}>
                                            {item.score?.toFixed(1) ?? "0.0"}
                                        </span>
                                        &nbsp;
                                        <span className="text-muted" style={{fontSize: "0.85rem"}}>
                                            ({item?.scoreBreakdown?.totalReviews || 0})
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        );
    }

    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };

    toggleSearchServices = (event) => {
        event.preventDefault();
        this.props.history.push("/");
    }

    toggleSearchArticles = () => {
        event.preventDefault();
        this.props.history.push("/knowledgeCentre");
    }

    toggleSearchReviews = () => {
        this.setState({
            collapseSearchReviews: !this.state.collapseSearchReviews,
            collapseSearchArticles: false,
            collapseSearchServices: false // Close the services section when articles is toggled
        });
    }

    onSearchInputChange = (event) => {
        let term = event.target.value;
        this.setState({term: event.target.value})
        console.log(this.state.term)
    }

    onSearch = event => {
        const filteredItems = _.filter(this.state.completeContentList, (item) => {
            return _.includes(item.companyName.toLowerCase(), this.state.term.toLowerCase())
        });
        console.log(filteredItems)
        this.setState({searchList: filteredItems});
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    showData = (paginatedItems, completeContentList, paz) =>{
        if(paginatedItems.length > 0){
           return ( <>

           </>)
        } else{
            return <h1>No Data available to show!</h1>
        }
    }



    render() {
        const {completeContentList, currentPage, pageSize, searchList} = this.state;
        const startIndex = (currentPage - 1) * pageSize;
        const paginatedItems = searchList.slice(startIndex, startIndex + pageSize);

        return (
            <div>
                {/*Nav Bar*/}
                <AppNavBar loginModalToggle={this.toggleModal}/>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {/* Hero Banner */}
                <div className="hero-banner" style={{height:"256px"}}>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>Company Reviews </p>
                                    <h1 style={{textAlign: "start"}}>Brands you can trust.</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <br/>
                <br/>
                <br/>
                {/* Collapsible Sections */}
                <Container className={"mt-10"}
                           style={{
                               border: "2px solid #4E5F7A",
                               padding: "1.5rem",
                               borderRadius: "2px",
                               marginTop: "2.5rem", // Adjust to divide the buttons in half
                               position: "relative",
                               zIndex: "1"
                           }}>
                    {/* Search Services */}
                    <div className="text-center" style={{marginTop: "-4rem"}}>
                        <Button color="white" onClick={this.toggleSearchServices} className="mb-3"
                                style={{
                                    width: "30%",
                                    fontSize: isMobile ? "0.9rem" : "1.5rem",
                                    padding: "1.5%"
                                }}>
                            {isMobile ? "Search" : "Search"}
                        </Button>

                        {/*Xare View*/}
                        <Button color="default" className="mb-3"
                                style={{
                                    width: "30%",
                                    fontSize: isMobile ? "0.9rem" : "1.5rem",
                                    padding: "1.5%",
                                    marginLeft: "-0.4rem"
                                }}>
                            {isMobile ? "Partners" : "Partners"}
                        </Button>
                        {/* Search Articles */}
                        <Button color="white" onClick={this.toggleSearchArticles} className="mb-3"
                                style={{
                                    width: "30%",
                                    fontSize: isMobile ? "0.9rem" : "1.5rem",
                                    padding: "1.5%",
                                    marginLeft: "-0.5rem"
                                }}>
                            {isMobile ? "Knowledge" : "Knowledge"}
                        </Button>
                    </div>
                    <Collapse isOpen={this.state.collapseSearchServices}>
                    </Collapse>


                    <Collapse isOpen={this.state.collapseSearchArticles}>
                    </Collapse>
                    <Collapse isOpen={this.state.collapseSearchReviews}>
                        <Form onSubmit={(e) => {
                            e.preventDefault()
                            this.onSearch();
                        }}>
                            <FormGroup>
                                <Label for="searchText">Search Companies</Label>
                                <Input onChange={this.onSearchInputChange} type="text" name="searchText"
                                       id="searchText"/>
                            </FormGroup>
                            <div className="text-center">
                                <Button color="default" outline onClick={this.onSearch}
                                        type="button">{"Search"}</Button>
                            </div>
                        </Form>
                    </Collapse>
                </Container>
                <br/>
                <br/>
                <br/>
                <Container>

                    {paginatedItems.length > 0 ?
                        <>
                            {this.renderCards(paginatedItems)}
                        <Paginations
                            totalItems={completeContentList.length}
                            pageSize={pageSize}
                            currentPage={currentPage}
                            onPageChange={this.onPageChange}
                        />
                        {/*<ReviewCompaniesCarousel companies={completeContentList}/>*/}
                    </> : (<h1></h1>)}


                </Container>
                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>
                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                            onClick={(event) => {
                                                this.props.history.push("/aboutUs")
                                            }}
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        );
    }
}

export default XareView;
